import { postItem, deleteItem, patchItem } from "utils/ApiUtils";
import { Contact } from 'classes';
import ODataUtil from "./ODataUtil";

const contactEndpoint = "/Contact";
const projectContactEndpoint = "/ProjectContact";


async function getContacts(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = Contact;
  const endpoint = projectContactEndpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  return data;
};

async function addContact(projectId, data) {
  const resourcePath = `${contactEndpoint}/Add`;

  const params = `?projectId=${projectId}`;

  const result = await postItem(resourcePath, params, data);

  return result;
};


async function deleteContact(projectId, contact) {
  const resourcePath = `${contactEndpoint}/Delete`;

  const params = `?projectId=${projectId}&contactId=${contact.ContactId_Contact}`;

  const result = await deleteItem(resourcePath, params);

  return result;
};

async function updateContact(projectId, contactId, data) {
  const resourcePath = `${contactEndpoint}/Update`;

  data.ContactId = contactId;

  const params = `?contactid=${contactId}`;

  const result = await patchItem(resourcePath, params, data);

  return result;
};

export { Contact, getContacts, addContact, deleteContact, updateContact };